{
  "0ddf43e264f68a12": "Time requested",
  "0f295eecfb3433d7": "Verified Shifts",
  "19c73a5cdf346d96": "Professional",
  "1c525cb12fd03c7c": "Fee Details",
  "2035fb74b10109c5": "Pending break payment request",
  "215020d85a22dd6d": "Charge Breakdown",
  "33c8e8de41c3a351": "Unverified",
  "3a8931a9b2f6bf69": "Dispute",
  "3c653dabeef2e3c2": "Shifts",
  "3ec6e3941da4c010": "Verify Shift?",
  "45989de49fb7f66d": "Details",
  "45b63ffd01af7b9c": "Rate",
  "4f7838402f37674e": "Verified",
  "526e0087cc3f254d": "Description",
  "62d6ee886349c247": "Shift Times",
  "6d80486cc33a915c": "Fees",
  "79c2657890c42470": "View dispute",
  "833f7959e353683d": "Cannot verify shifts that haven't started yet",
  "872d718dc4dcdfb8": "No verified shifts",
  "87b17944085875ed": "Pending Requests",
  "883a9f47c79e8901": "No pending requests",
  "88494a53861aa061": "Off-cycle",
  "8cd819f501f556ca": "Failed to load upcoming charges. Please try again later.",
  "920e413c7d411b61": "Status",
  "942087cc2d41e013": "Retry",
  "96173be4ed57f043": "No fees",
  "99c40ab405926cb5": "Date",
  "9a57000511753181": "Fee Type",
  "a2fb237d15320535": "Upcoming Charges",
  "a600b900f83db6cb": "Close panel",
  "ad30ad3bffc8184d": "Shift Type",
  "aff0766a5290e117": "Review",
  "b3b310ca1276b3bb": "Disputed",
  "b5396293134e602c": "Failed to load pending requests. Please try again later.",
  "bdd239ff57e1d330": "Expires at {{formattedExpiration}}",
  "c011d6097bfbc8e9": "License",
  "c972b45d5870fe90": "Additional charges for late cancellations, sent-home shifts, and other non-shift fees.",
  "c9b3c38247f744e1": "Total",
  "ccde26902b9baa9d": "Paid hours",
  "d1bf045bb524dae5": "View details",
  "d8edefa82a64defb": "Paid Hours",
  "ebe4ecdf967339f2": "Expiration N/A",
  "f57c4300d5f50247": "Rate (/hr)",
  "f71081fb0af48ae6": "Break"
}
